<div role="tablist" class="aa-wizard">
  <div class="aa-all-steps">
    @for (step of steps; track step; let idx = $index; let isLast = $last) {
      <div class="aa-step" [class.active]="step.active" [class.disabled]="step.disabled" [class.deactivated]="step.deactivated">
        <div
          [style.height.px]="height"
          class="aa-step-title"
          (click)="activateStep(idx)"
          >
          @if (!isLast) {
            <div class="step">
              <div class="step-text">
                {{ 'WIZARD.STEPS.NAME' | translate }}&nbsp;{{ idx + 1 }}
              </div>
              @if (step.valid) {
                <aa-icon-circle class="blue duotone" [faIcon]="'fal fa-check'"></aa-icon-circle>
              }
            </div>
          }
          @if (isLast) {
            <div class="step">
              &nbsp;
            </div>
          }
          <div class="title">
            {{ step.title }}
            <ng-template
              [ngTemplateOutlet]="$safeNavigationMigration(step.titleTpl?.templateRef)"
            ></ng-template>
          </div>
        </div>
        <div class="aa-step-border"></div>
      </div>
    }
  </div>
  <div class="aa-next-step">
    <div class="aa-step" [class.disabled]="nextDisabled">
      <div [style.height.px]="height" class="aa-step-title" (click)="clickNextStep()">
        <div class="step">&nbsp;</div>
        <div class="title">
          {{'WIZARD.BUTTONS.NEXT' | translate}}
        </div>
      </div>
    </div>
  </div>
</div>
<div class="aa-step-content">
  @for (step of steps; track step) {
    @if (step.active) {
      <div
        role="tabpanel"
        [attr.aria-labelledby]="step.id"
        id="{{ step.id }}-panel"
        >
        <ng-template
          [ngTemplateOutlet]="$safeNavigationMigration(step.contentTpl?.templateRef)"
        ></ng-template>
      </div>
    }
  }
</div>
